import { UserOutlined } from "@ant-design/icons";
import { Avatar as AvatarAntd } from "antd";

const Avatar = ({ imageUrl }) => {
  if (!imageUrl) {
    return (
      <AvatarAntd
        icon={<UserOutlined />}
        alt="profile"
        // size={30}
      />
    );
  }

  return <AvatarAntd src={imageUrl} alt="profile" />;
};

export default Avatar;
